import 'css-chunksrc/client/scenes/appNotifications/notificationWrapper/styles.scss';export default {
  "notificationWrapper": "_notificationWrapper_88tav_1",
  "dismissed": "_dismissed_88tav_8"
};